import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { fundActions } from '../../actions/fund.action';
import { groupsActions } from '../../actions/groups.actions';
import { lotsActions } from '../../actions/lots.actions';
import { NAME_BY_ROLES } from '../../routes/costants';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { userActions } from '../../actions/user.actions';
import { personalSettingsActions } from '../../actions/pesonalSettings.actions';

const ProtectedRoutes = ({ allowedRoles }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.userInfo);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const verify = searchParams.get('verify_url');

    const token = user.token;
    const role = user.role;
    const id = user.id;

    useEffect(() => {
        if (verify) {
            const url = verify.substring(
                verify.indexOf('/api/email/verify') + 4,
            );
            dispatch(personalSettingsActions.verifyEmail(url));
        }
    }, [verify]);

    useEffect(() => {
        if (token) {
            dispatch(userActions.getUser(id));
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            dispatch(groupsActions.getGroups());
        }
    }, []);

    useEffect(() => {
        if (token) {
            dispatch(fundActions.getTotalFund());
        }
    }, []);

    useEffect(() => {
        if (token) {
            dispatch(userActions.getUsers());
        }
    }, []);

    useEffect(() => {
        if (token) {
            dispatch(lotsActions.getCash());
        }
    }, []);

    if (allowedRoles) {
        return token ? (
            allowedRoles.includes(role) ? (
                <Outlet />
            ) : (
                <Navigate
                    replace
                    state={{ from: location }}
                    to={NAME_BY_ROLES[`${role}`]}
                />
            )
        ) : (
            <Navigate replace state={{ from: location }} to="/login" />
        );
    }
    return token ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
